import { useRef, useMemo } from 'react';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  HStack,
  Box,
  Text,
  Icon,
  Divider,
  Select,
  FormControl,
} from '@chakra-ui/react';

import { ReactComponent as FiltersIcon } from '../../../assets/icons/filters.svg';
import { DrawerFilter } from '../../../models/components';
import { useForm, FieldValues } from 'react-hook-form';

export const FilterDrawer = ({
  isOpen,
  onClose,
  filters,
}: {
  isOpen: boolean;
  onClose: (filterValues?: any) => void;
  filters: DrawerFilter[];
}) => {
  const btnRef = useRef();

  // Dynamic form — field names come from `filters` props, not statically known.
  // Annotate as FieldValues so RHF's Path<T> resolves to `string` for register(name).
  const defaultValues = useMemo<FieldValues>(() => {
    const defaultFilterValues: FieldValues = {};
    filters.forEach(filter => {
      defaultFilterValues[filter.name] = filter.value;
    });

    return defaultFilterValues;
  }, [filters]);

  const { register, getValues } = useForm<FieldValues>({
    defaultValues,
  });

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
    >
      <DrawerContent>
        <DrawerHeader>
          <HStack align="center">
            <HStack>
              <Icon as={FiltersIcon} />
              <Text>Filters</Text>
            </HStack>
            <DrawerCloseButton />
          </HStack>
        </DrawerHeader>
        <Divider />

        <DrawerBody>
          {filters.map(({ label, type, list, name }) => (
            <Box key={name}>
              <Text>{label}</Text>

              <FormControl flexBasis="50%" mt="2">
                {type === 'select' && (
                  <Select {...register(name)}>
                    {list.map(({ text, value }) => (
                      <option value={value} key={value}>
                        {text}
                      </option>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Box>
          ))}
        </DrawerBody>

        <DrawerFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="submit"
            bg="custom_orange.2"
            _hover={{ bg: 'custom_orange.2' }}
            color="white"
            onClick={() => onClose(getValues())}
          >
            Save
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
